module.exports = __webpack_public_path__ + "static/media/wd18.4c707c97.jpeg";